import {Modal} from "antd";
import React from "react";
import {useFetch} from "../../../../hooks/useFetch";
import {useStore} from "../../../../hooks/useStore";

const SendBackToCompanyModal = ({
    sendBackToCompanyModalVisible,
    setSendBackToCompanyModalVisible,
    shipmentId,
    undeliveredShipmentId,
    undeliveredShipmentsRefetch
}) => {
    const stores = useStore();

    const [sendBackToCompanyLoading, sendBackToCompany, , , refetch] = useFetch({
        fetchFn: () => stores.transferStore.sendBackToCompany({shipmentId, undeliveredShipmentId}),
        initialCall: false,
        showLoading: true
    });

    const handleSendBackToCompany = async () => {
        try {
            await refetch();
            undeliveredShipmentsRefetch();
            setSendBackToCompanyModalVisible(false);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <Modal
            title="Firmaya Geri Gönder"
            visible={sendBackToCompanyModalVisible}
            onOk={handleSendBackToCompany}
            okText="Geri Gönder"
            cancelText="İptal"
            onCancel={() => setSendBackToCompanyModalVisible(false)}
            confirmLoading={sendBackToCompanyLoading}
        >
            <div>Firmaya geri göndermek istediğinizden emin misiniz?</div>
        </Modal>
    );
};

export default SendBackToCompanyModal;
